module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page partners-page mx-5"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-text": ""
    }
  }, [_c('h1', [_vm._v("YouSound "), _c('br'), _vm._v("Partners")]), _vm._v(" "), _c('span', [_c('v-btn', {
    staticClass: "black white--text mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("south")]), _vm._v(" "), _c('span', [_vm._v("Learn More")])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-img": ""
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "/static/images/up_partnerbg.svg"
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "layer-flex": "",
      "flex-img": ""
    }
  }, [_c('img', {
    attrs: {
      "width": "80%",
      "src": "/static/images/up_growthbg.svg"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-text": ""
    }
  }, [_c('h2', [_vm._v("Get Paid")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Share ad & subscription revenue")]), _vm._v(" "), _c('li', [_vm._v("User-centric payouts")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-faq"
  }, [_c('div', {
    staticClass: "__intro-title"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('accordion', {
    attrs: {
      "accordions": _vm.accordions,
      "leftIcon": "add"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7819fd59","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partners/index.vue
// module id = 1787
// module chunks = 180